function normalizeSpacing(media) {
  return media.replace(/:\s*/g, ': ').replace(/\s{2,}/g, ' ').trim();
}

// Unbounce uses 600px as the mobile max-width breakpoint, so desktop
// preloads need min-width: 601px to avoid firing on mobile devices.
export function transformMediaForPreload(rawMediaQuery) {
  if (!rawMediaQuery) return '(min-width: 601px)';

  const isMobile = /max-width/i.test(rawMediaQuery);
  const conditions = rawMediaQuery.split(',').map((part) => {
    let clean = part.trim().replace(/^only\s+screen\s+and\s+/i, '').trim();
    if (!isMobile && !/min-width/i.test(clean)) {
      clean = `(min-width: 601px) and ${clean}`;
    }
    return clean;
  });

  return normalizeSpacing(conditions.join(', '));
}

export function generateLabel(rawMediaQuery) {
  if (!rawMediaQuery) return 'Desktop Standard';

  const isMobile = /max-width/i.test(rawMediaQuery);
  const platform = isMobile ? 'Mobile' : 'Desktop';

  const dprMatch = rawMediaQuery.match(/-device-pixel-ratio:\s*([\d.]+)/i);
  const dpiMatch = rawMediaQuery.match(/min-resolution:\s*(\d+)\s*dpi/i);

  if (!dprMatch && !dpiMatch) return `${platform} Standard`;

  const dpr = dprMatch ? parseFloat(dprMatch[1]) : null;
  const dpi = dpiMatch ? parseInt(dpiMatch[1], 10) : null;

  if ((dpr !== null && dpr <= 1.5) || (dpi !== null && dpi <= 120))
    return `${platform} Retina`;

  if (dpr !== null) return `${platform} Retina ${dpr}x`;
  if (dpi !== null) return `${platform} Retina ${dpi}dpi`;

  return `${platform} Retina`;
}

export function computeSortOrder(rawMediaQuery) {
  if (!rawMediaQuery) return 150;

  const isMobile = /max-width/i.test(rawMediaQuery);
  const hasResolution = /device-pixel-ratio|min-resolution/i.test(rawMediaQuery);
  const dprMatch = rawMediaQuery.match(/-device-pixel-ratio:\s*([\d.]+)/i);
  const dpr = dprMatch ? parseFloat(dprMatch[1]) : 1;

  let order = isMobile ? 0 : 100;
  if (!hasResolution) order += 50;
  else order += Math.max(0, 10 - dpr);

  return order;
}

export function resolveMediaQuery(rawMediaQuery) {
  return {
    label: generateLabel(rawMediaQuery),
    media: transformMediaForPreload(rawMediaQuery),
    sortOrder: computeSortOrder(rawMediaQuery),
  };
}
